const DOMAIN_ENUM_BY_INDEX = [
  "PHYSICAL",
  "EMOTIONAL",
  "ACCEPTANCE",
  "RELATIONSHIPS",
  "LOVING-KINDNESS",
  "INTELLECTUAL",
];

const MAX_MIDDAY_WORDS_PER_FIELD = 5;

function _asNumber(value, fieldName) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    throw new Error(`${fieldName} must be a number`);
  }
  return n;
}

function _nonEmptyLines(values) {
  return (values || [])
    .map((v) => (typeof v === "string" ? v.trim() : ""))
    .filter(Boolean);
}

function _wordCount(text) {
  return String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

export function buildMorningCheckinPayload({ values }) {
  const moodIdx = _asNumber(values?.mood, "mood");
  const sleepIdx = _asNumber(values?.sleep, "sleep");
  const stressIdx = _asNumber(values?.stress, "stress");
  const domainIdx = _asNumber(values?.domain, "domain");

  const domain = DOMAIN_ENUM_BY_INDEX[domainIdx];
  if (!domain) {
    throw new Error("Invalid domain");
  }

  return {
    type: "MORNING",
    answers: [
      { question_no: 1, answer_number: moodIdx + 1 },
      { question_no: 2, answer_number: sleepIdx + 1 },
      { question_no: 3, answer_number: stressIdx + 1 },
      { question_no: 4, answer_domain: domain },
    ],
  };
}

export function buildMiddayCheckinPayload({ values }) {
  const accomplished = _nonEmptyLines(values?.accomplished);
  const learned = _nonEmptyLines(values?.learned);
  const enjoyed = _nonEmptyLines(values?.enjoyed);

  if (!accomplished.length || !learned.length || !enjoyed.length) {
    throw new Error("Please complete all three sections");
  }

  const allEntries = [...accomplished, ...learned, ...enjoyed];
  for (const entry of allEntries) {
    if (_wordCount(entry) > MAX_MIDDAY_WORDS_PER_FIELD) {
      throw new Error(`Each Mid-Day entry must be ${MAX_MIDDAY_WORDS_PER_FIELD} words or fewer`);
    }
  }

  return {
    type: "MIDDAY",
    answers: [
      { question_no: 1, answer_text: accomplished.join("\n") },
      { question_no: 2, answer_text: learned.join("\n") },
      { question_no: 3, answer_text: enjoyed.join("\n") },
    ],
  };
}

export function buildNightCheckinPayload({ values }) {
  const dayRating = _asNumber(values?.day_rating, "day_rating");
  const productivity = _asNumber(values?.productivity, "productivity");
  const creativity = _asNumber(values?.creativity, "creativity");

  return {
    type: "NIGHT",
    answers: [
      { question_no: 1, answer_number: dayRating },
      { question_no: 2, answer_number: productivity },
      { question_no: 3, answer_number: creativity },
    ],
  };
}
